import PrivacyPolicy from "components/PrivacyPolicy/PrivacyPolicy";
import TermsOfUse from "components/TermsOfUse/TermsOfUse";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon, List, ListItem, Message } from "semantic-ui-react";

const FOOTER_MINIMIZED_STORAGE_KEY = "materialportal.footerMinimized";
const FOOTER_EXPAND_LABEL = "Expand footer";
const FOOTER_MINIMIZE_LABEL = "Minimize footer";

const getInitialFooterState = () => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.localStorage.getItem(FOOTER_MINIMIZED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

const Footer = () => {
  const { t } = useTranslation("common");
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(getInitialFooterState);
  const version = process.env.REACT_APP_VERSION ?? "0.0.0";

  useEffect(() => {
    try {
      window.localStorage.setItem(FOOTER_MINIMIZED_STORAGE_KEY, String(isMinimized));
    } catch {
      // Ignore storage failures so the footer still works in restricted browsers.
    }
  }, [isMinimized]);

  return (
    <Message attached="bottom" className={`app-footer${isMinimized ? " minimized" : ""}`}>
      <div className="app-footer-bar">
        {!isMinimized ? (
          <List horizontal divided className="app-footer-links">
            <ListItem as="a" className="footer-link" onClick={() => setPrivacyModalOpen(true)}>
              {t("footer_privacy_policy")}
            </ListItem>
            <ListItem as="a" className="footer-link" onClick={() => setTermsModalOpen(true)}>
              {t("footer_terms_of_use")}
            </ListItem>
            <ListItem className="app-footer-version">Version: {version}</ListItem>
          </List>
        ) : null}
        <button
          type="button"
          className="app-footer-toggle"
          onClick={() => setIsMinimized((currentState) => !currentState)}
          aria-expanded={!isMinimized}
          aria-label={isMinimized ? FOOTER_EXPAND_LABEL : FOOTER_MINIMIZE_LABEL}
          title={isMinimized ? FOOTER_EXPAND_LABEL : FOOTER_MINIMIZE_LABEL}
        >
          <Icon
            name={isMinimized ? "angle double up" : "angle double down"}
            size={isMinimized ? "mini" : "small"}
            fitted
          />
        </button>
      </div>
      <PrivacyPolicy open={privacyModalOpen} onClose={() => setPrivacyModalOpen(false)} />
      <TermsOfUse open={termsModalOpen} onClose={() => setTermsModalOpen(false)} />
    </Message>
  );
};

export default Footer;
